/** @format */

import type { HomrVisualAssets } from '@shared/data-access/interfaces';

export interface HomrImageBanner {
  visualAssets?: [HomrVisualAssets];
  altText?: string;
  animation?: string;
  DataEMTag?: string;
  gif?: string;
  gifMobile?: string;
  image?: string;
  link?: string;
  mobileImg?: string;
  youtubeId?: string;
}
